/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Initializing_Site_CommanderInputs */

const en_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initializing Site Commander`)
};

const es_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializando Comandante del Sitio`)
};

const fr_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialisation du Site Commander`)
};

const de_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site Commander wird initialisiert`)
};

const ja_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイトコマンダーを初期化中`)
};

const zh_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在初始化站点指挥官`)
};

const ar_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري تهيئة مدير الموقع`)
};

const id_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menginisialisasi Komandan Situs`)
};

const it_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizializzazione di Site Commander in corso`)
};

const ru_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инициализация управления сайтом`)
};

const pt_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializando Comandante do Site`)
};

const ko_initializing_site_commander = /** @type {(inputs: Initializing_Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사이트 커맨더 초기화 중`)
};

/**
* | output |
* | --- |
* | "Initializing Site Commander" |
*
* @param {Initializing_Site_CommanderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const initializing_site_commander = /** @type {((inputs?: Initializing_Site_CommanderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Initializing_Site_CommanderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_initializing_site_commander(inputs)
	if (locale === "es") return es_initializing_site_commander(inputs)
	if (locale === "fr") return fr_initializing_site_commander(inputs)
	if (locale === "de") return de_initializing_site_commander(inputs)
	if (locale === "ja") return ja_initializing_site_commander(inputs)
	if (locale === "zh") return zh_initializing_site_commander(inputs)
	if (locale === "ar") return ar_initializing_site_commander(inputs)
	if (locale === "id") return id_initializing_site_commander(inputs)
	if (locale === "it") return it_initializing_site_commander(inputs)
	if (locale === "ru") return ru_initializing_site_commander(inputs)
	if (locale === "pt") return pt_initializing_site_commander(inputs)
	return ko_initializing_site_commander(inputs)
});